// Header — toggle the bottom-fixed menu on mobile.

function initHeader() {
    const nav = document.querySelector(".site-nav");
    if (!nav) return;

    const toggle = nav.querySelector(".site-nav__toggle");
    if (!toggle) return;

    toggle.addEventListener("click", () => {
        const isOpen = nav.classList.toggle("is-open");
        toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });

    // Close the menu after tapping a link (mobile).
    nav.querySelectorAll(".nav-link").forEach((link) => {
        link.addEventListener("click", () => {
            nav.classList.remove("is-open");
            toggle.setAttribute("aria-expanded", "false");
        });
    });

    initDockToFooter(nav);
}

/**
 * Dock the bottom-fixed nav onto the footer.
 *
 * The nav floats `gap`px above the viewport bottom. As the page scrolls down,
 * the footer rises; once its top edge reaches the nav's vertical midpoint (i.e.
 * the footer would cover 50% of the nav's height), the nav stops being fixed and
 * parks `gap`px above the footer, scrolling away with it. Scrolling back up
 * re-pins it to the viewport.
 *
 * While docked the nav is reparented to <body> so `position: absolute` resolves
 * against the document instead of the fixed `.header` containing block.
 */
function initDockToFooter(nav) {
    const footer = document.querySelector(".footer");
    const header = nav.parentNode; // the fixed .header it lives in
    if (!footer || !header) return;

    // Read the floating gap once, while still fixed (handles any rem root size).
    const gap = parseFloat(getComputedStyle(nav).bottom) || 0;

    let docked = false;
    let raf = null;

    const update = () => {
        raf = null;
        const navH = nav.offsetHeight;
        const footerTop = footer.getBoundingClientRect().top; // viewport coords
        // Fixed nav's vertical midpoint, measured from the viewport top.
        const midpoint = window.innerHeight - gap - navH / 2;

        if (footerTop <= midpoint) {
            if (!docked) {
                document.body.appendChild(nav);
                nav.classList.add("is-docked");
                docked = true;
            }
            // Park the nav `gap` above the footer, in document coordinates.
            const footerPageTop = window.scrollY + footer.getBoundingClientRect().top;
            nav.style.top = footerPageTop - gap - nav.offsetHeight + "px";
        } else if (docked) {
            header.appendChild(nav);
            nav.classList.remove("is-docked");
            nav.style.top = "";
            docked = false;
        }
    };

    const schedule = () => {
        if (raf) return;
        raf = requestAnimationFrame(update);
    };

    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
    update();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeader);
} else {
    initHeader();
}
